import { CtaEvent } from '@shared/v2/components/createRoomOptionCTA/types';
import { PackageOption } from '@shared/v2/utils/getPackageOptions';

import { OnCtaClickOpts } from '@/v2/components/pages/PackageViewV2/hooks/useCtaOnClick/useCtaOnClick';
import { UI } from '@/v2/types';
import { createCtx } from '@/v2/utils/createCtx';

export type RoomOptionsContextValue = {
  isOriginSelected: boolean;
  isPackageSelected: boolean;
  isPackageOptionsOpen: boolean;
  setIsPackageOptionOpen: (isOpen: boolean) => void;
  route: string;
  isPreSearch: boolean;
  isBestRates: boolean;
  roomOptions: {
    main: UI.RoomOption[] | undefined | null;
    other: UI.RoomOption[] | undefined | null;
    all: UI.RoomOption[] | undefined;
  };
  selectedRoomOption: UI.RoomOption | undefined;
  isLoading: boolean;
  travellerCount: number | undefined | null;
  onCtaClick: (event: CtaEvent, opts: OnCtaClickOpts) => void;
  packageOffers: UI.PackageOffer[] | undefined;
  flightInclusion:
    | {
        code: string;
        name: string;
        terms: {
          text: string;
        };
      }
    | undefined;
  showCampaignPackageOptionVariants: boolean;
  isCampaignAvailable: boolean;
  selectedPackageOption: PackageOption | undefined;
  nonCampaignAltRoomOption: UI.RoomOption | undefined;
  lastSearchCausedSwitchToCampaignOptions: boolean;
  packageOptions: PackageOption[];
  flightOptions: UI.FlightOptions | undefined;
};

export const [useRoomOptionsData, RoomOptionsDataProvider] =
  createCtx<RoomOptionsContextValue>();
